var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreesPlanted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.28 54.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #add59e;\n      }\n\n      .cls-2 {\n        fill: #43a12a;\n      }\n\n      .cls-3 {\n        fill: #effbe5;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 29.14,
    cy: 27.39,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.14,50.89c-12.96,0-23.5-10.54-23.5-23.5S16.18,3.89,29.14,3.89s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM29.14,5.39c-12.13,0-22,9.87-22,22s9.87,22,22,22,22-9.87,22-22S41.27,5.39,29.14,5.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pine_877553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    className: "cls-2",
    d: "M30.83,31.83l-2.75-3.85h1.06c.33,0,.6-.27.6-.6,0-.12-.03-.24-.1-.33l-2.58-3.87h.88c.33,0,.6-.27.6-.6,0-.13-.04-.26-.12-.36l-3-4.84c-.22-.27-.61-.3-.87-.09-.03.03-.06.05-.09.09l-3,4.84c-.2.27-.15.64.12.84.1.08.23.12.36.12h.88l-2.58,3.87c-.18.28-.11.65.17.83.1.07.22.1.33.1h1.06l-2.79,3.85c-.19.27-.13.64.14.84.1.07.22.11.35.11h10.84c.33,0,.6-.27.6-.6,0-.13-.04-.25-.11-.35Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    className: "cls-2",
    d: "M38.78,36.42h-4.24v-2.44h-2.4v2.44h-6v-2.44h-2.4v2.44h-4.24c-.33,0-.6.27-.6.6s.27.6.6.6h19.28c.33,0,.6-.27.6-.6s-.27-.6-.6-.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    className: "cls-2",
    d: "M39.27,31.83l-2.79-3.85h1.06c.33,0,.6-.27.6-.6,0-.12-.03-.24-.1-.33l-2.58-3.87h.88c.33,0,.6-.27.6-.6,0-.13-.04-.26-.12-.36l-3-4.84c-.22-.27-.61-.3-.87-.09-.03.03-.06.05-.09.09l-3,4.84c-.2.27-.15.64.12.84.1.08.23.12.36.12h.88l-1.36,2.04.78,1.17c.54.81.34,1.91-.46,2.47l1.63,2.28c.34.48.42,1.1.21,1.65h6.76c.33,0,.6-.27.6-.6,0-.13-.04-.25-.11-.35h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesPlanted);
export default __webpack_public_path__ + "static/media/Trees Planted.1a5b3986d3438d835ceb53454ce9a101.svg";
export { ForwardRef as ReactComponent };